import base from "/app/images/soundcloud.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");